// extracted by mini-css-extract-plugin
export var container = "course-movies-list-module--container--a03d7";
export var emptyInfo = "course-movies-list-module--empty-info--6597c";
export var item = "course-movies-list-module--item--2f003";
export var labelName = "course-movies-list-module--label-name--50979";
export var movieCounter = "course-movies-list-module--movie-counter--ad923";
export var playlist = "course-movies-list-module--playlist--b3b4d";
export var topWrapper = "course-movies-list-module--top-wrapper--6d882";
export var trainingTypeWrapper = "course-movies-list-module--training-type-wrapper--260fd";
export var wrapper = "course-movies-list-module--wrapper--6521d";